import { render, staticRenderFns } from "./giftRecordPage.vue?vue&type=template&id=5e2b03b4&scoped=true"
import script from "./giftRecordPage.vue?vue&type=script&lang=js"
export * from "./giftRecordPage.vue?vue&type=script&lang=js"
import style0 from "./giftRecordPage.vue?vue&type=style&index=0&id=5e2b03b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2b03b4",
  null
  
)

export default component.exports